import React from 'react'
import Sidebar from '../../layouts/Sidebar'
import Topbar from '../../layouts/Topbar'
import Stats from './sub_components/Stats'

const Dashboard = () => {
  return (
    <>
    <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
        <Topbar/>
        <Sidebar/>
        <div>
          <Stats/>
        </div>

    </div>

    </>

  )
}

export default Dashboard